var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 43,
    viewBox: "0 0 41 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7583 3.52942H9.82127C8.9925 3.52942 8.19768 3.90127 7.61166 4.56316C7.02564 5.22505 6.69641 6.12277 6.69641 7.05883V35.2941C6.69641 36.2302 7.02564 37.1279 7.61166 37.7898C8.19768 38.4517 8.9925 38.8235 9.82127 38.8235H28.5704C29.3992 38.8235 30.194 38.4517 30.78 37.7898C31.366 37.1279 31.6953 36.2302 31.6953 35.2941V15.8824L20.7583 3.52942Z",
    fill: "#62B373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7583 3.52942L20.7583 15.8824H31.6953",
    fill: "#62B373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7583 3.52942H9.82127C8.9925 3.52942 8.19768 3.90127 7.61166 4.56316C7.02564 5.22505 6.69641 6.12277 6.69641 7.05883V35.2941C6.69641 36.2302 7.02564 37.1279 7.61166 37.7898C8.19768 38.4517 8.9925 38.8235 9.82127 38.8235H28.5704C29.3992 38.8235 30.194 38.4517 30.78 37.7898C31.366 37.1279 31.6953 36.2302 31.6953 35.2941V15.8824M20.7583 3.52942L31.6953 15.8824M20.7583 3.52942L20.7583 15.8824H31.6953",
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.82 17.2059C35.0252 16.9741 35.2688 16.7903 35.5369 16.6649C35.8049 16.5395 36.0923 16.4749 36.3824 16.4749C36.6726 16.4749 36.9599 16.5395 37.228 16.6649C37.4961 16.7903 37.7397 16.9741 37.9449 17.2059C38.15 17.4376 38.3128 17.7127 38.4238 18.0155C38.5349 18.3183 38.592 18.6428 38.592 18.9706C38.592 19.2983 38.5349 19.6228 38.4238 19.9256C38.3128 20.2284 38.15 20.5035 37.9449 20.7353L27.3985 32.6471L23.1018 33.9706L24.2736 29.1176L34.82 17.2059Z",
    fill: "#62B373",
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/FileIcon.543030ee173bbdfd16b15c8f7457007f.svg";
export { ForwardRef as ReactComponent };